import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-request-quickview',
  templateUrl: './request-quickview.component.html',
  styleUrls: ['./request-quickview.component.css']
})
export class RequestQuickviewComponent implements OnInit {
  @Input() reqid = '';
  @Input() cid = '';
  @Output() openModalMore = new EventEmitter();
  @Output() openModalChild = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}
